import useGetWsLogic from './useGetWsLogic';

export default useGetWsLogic;
